import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import { setActivePinia } from 'pinia';
import { useAuthStore } from '@/store';

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */

const pinia = createPinia();
setActivePinia(pinia);
const authStore = useAuthStore();

function loadLocaleMessages() {
  // const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+[index]+\.js$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\/index\.js/i);
    // const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });
  return messages;
}

export default createI18n({
  locale: authStore.getLanguage,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
  messages: loadLocaleMessages(),
});
